import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-46" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-48" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-49" data-mp="57ebob4uv5ec">
            <span aria-hidden="true" data-id="element-50" data-mp="3mfsxp4dt4r2a">🔬 </span>La Differenza di YOGA PRONTA™
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-51" data-mp="3rh8kp1zjp7nb">
            Da insegnante esausta a{' '}
            <span className="italic text-brand" data-id="element-52" data-mp="3if8ylv9obddi">guida sicura di sé.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-53" data-mp="1bpklt10z151v">
            Dai alle tue lezioni un impatto visivo professionale, ai tuoi allievi un&apos;esperienza
            profonda e a te stessa il tempo di goderti di nuovo l&apos;insegnamento dello yoga.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-54" data-mp="1faddhg08n4gq">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-55" data-mp="1o1dog4sjnvpr" data-mpi={index}>
              <dt className="sr-only" data-id="element-56" data-mp="wbrc000t7bca">{stat.label}</dt>
              <dd data-id="element-57" data-mp="wd2bhnn81wxl">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-58" data-mp="1aa7e1dnq8do3">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-59" data-mp="15amdwzwtlz9s">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-60" data-mp="2gsnig3bx76n4">
          <div className="grid md:grid-cols-2" data-id="element-61" data-mp="2oqpg0c0v873n">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-62" data-mp="2sskivkyg2sjj">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-63" data-mp="2sr13rxoiynjc">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-64" data-mp="32qrzg2otn8l0" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-65" data-mp="2539mefo4nkb7">
                Prima di Yoga Pronta
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-66" data-mp="2a2w16tjlt8m4">
                Il costo dell&apos;improvvisazione
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-67" data-mp="2jtqps4kbokaq">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-68" data-mp="1mbz1qg8zw3rr">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-69" data-mp="1jras6lbtwmqm" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-70" data-mp="19t4ru85o7onv">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-71" data-mp="14v3abrnw7xei">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="10ujcsmzeqrru" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-73" data-mp="w2hqe88izko3">
                Con Yoga Pronta™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-74" data-mp="r1kdaa2dhgtg">
                Il sistema definitivo
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-75" data-mp="h4pdzoy9zce4">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-76" data-mp="d4f8edeeanzs">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-77" data-mp="16t4nel4kxk2v" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-78" data-mp="x1qfpq2h5dyn">
            Un sistema completo per pianificare meno e insegnare con più passione.
          </p>
        </div>
      </div>
    </section>;
}